import axios from 'axios'
import {
  setFormValues,
  setFilterValues,
  toggleFilterValues,
} from '../../modules/mutations.js'
import { i18n } from '../../plugins/i18n'
import { castAttributesForCamelCase } from '../../modules/string_converter'

export const companiesInvitations = {
  namespaced: true,
  state: {
    formValues: {
      store_uuids: []
    },
    data: null,
    meta: null,
    loading: false,
    loadError: false,
  },
  getters: {
    meta: (state) => state.meta
  },
  mutations: {
    readInvitations(state) {
      state.data = null
      state.loading = true
      state.loadError = false
    },
    apiConnect(state) {
      state.loading = true
      state.loadError = false
    },
    readInvitationsSuccess(state, payload) {
      state.data = payload.data
      state.loading = false
      state.loadError = false
    },
    createInvitationsSuccess(state) {
      state.loading = false
      state.loadError = false
    },
    updateInvitationsSuccess(state, payload) {
      state.data.forEach(function(val){
        if (val.id == payload.data.id) {
          val.attributes = payload.data.attributes
        }
      })
      state.loading = false
      state.loadError = false
    },
    deleteInvitationsSuccess(state, invitationId) {
      state.data = state.data.filter(function(value){
        return value.id != invitationId
      })
      state.loading = false
      state.loadError = false
    },
    apiFailure(state) {
      state.loading = false
      state.loadError = true
    },
    setMeta(state, meta) {
      state.meta = castAttributesForCamelCase(meta)
    },
    setFormValues,
    setFilterValues,
    toggleFilterValues,
  },
  actions: {
    readInvitations({ commit }, company_uuid) {
      commit('readInvitations')
      axios
        .get('/api/companies/' + company_uuid + '/invitations.json')
        .then(res => {
          commit('readInvitationsSuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
    readInvitationsForFilter({ commit }, { company_uuid, query }) {
      commit('readInvitations')
      axios
        .get('/api/companies/' + company_uuid + '/invitations.json', { params: query })
        .then(res => {
          commit('setMeta', res.data.meta)
          commit('readInvitationsSuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
    createInvitations({ commit }, { company_uuid, payload }) {
      commit('apiConnect')
      return axios
        .post('/api/companies/' + company_uuid + '/invitations.json', payload)
        .then(() => {
          commit('createInvitationsSuccess')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('pages.companies.managementMembers.sentInvitation') }, { root: true })
          return true
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
          return false
        })
    },
    updateInvitations({ commit }, { company_uuid, invitation_id }) {
      commit('apiConnect')
      axios
        .patch('/api/companies/' + company_uuid + '/invitations/' + invitation_id + '.json')
        .then(res => {
          commit('updateInvitationsSuccess', res.data)
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('pages.companies.managementMembers.resentInvitation') }, { root: true })
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
    deleteInvitations({ commit }, { company_uuid, invitation_id }) {
      commit('apiConnect')
      axios
        .delete('/api/companies/' + company_uuid + '/invitations/' + invitation_id + '.json')
        .then(() => {
          commit('deleteInvitationsSuccess', invitation_id)
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.canceled', { value: i18n.t('models.invitation.modelName') }) }, { root: true })
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
    setFormValues({ commit }, values) {
      commit('setFormValues', values)
    }
  }
}
